import React from "react";
import { SquareButton, Text } from "@themuse/design-system";
import { IconFilter, Search } from "@themuse/design-system/lib/components/Icons";
import { useSearchState } from "hooks/SearchContext";
import { useSearchHistory } from "hooks/SearchHistoryContext";
import { isMobile, toggleWindowFreeze } from "utils/browser";
import { getSelectedFiltersCount } from "utils/searchFacets";

import styles from "./SearchFilterToggleBar.module.scss";

interface SearchFilterToggleBarProps {
    open: boolean;
    onToggle: (open) => void;
}

const SearchFilterToggleBar = (props: SearchFilterToggleBarProps) => {
    const { onToggle, open } = props;
    const { filters, location } = useSearchState();
    const { searchHistory } = useSearchHistory();
    const selectedValuesCount = getSelectedFiltersCount(
        filters,
        location?.userSelectedLocation?.remote_work_location_type
    );

    const filterButtonOnClick = () => {
        onToggle(!open);
        if (isMobile()) {
            toggleWindowFreeze();
        }
    };

    const filterText = selectedValuesCount ? `Edit Filters  (${selectedValuesCount})` : "Edit Filters";
    const searchesText = searchHistory.length ? `Recent Searches (${searchHistory.length})` : "";

    return (
        <div className={styles.container}>
            <SquareButton className={styles.filterBtn} color="white" onClick={filterButtonOnClick}>
                <IconFilter className={styles.filterBtnIcon} />
                <Text textStyle="sans-serif-body-small" className={styles.filterBtnText}>{filterText}</Text>
                {searchesText ? (
                    <>
                        <br />
                        <span> | </span>
                        <Search className={styles.filterBtnIcon} />
                        <Text textStyle="sans-serif-body-small" className={styles.filterBtnText}>{searchesText}</Text>
                    </>
                ) : null}
            </SquareButton>
        </div>
    );
};

export default SearchFilterToggleBar;
